interface Props {
    onChange?: React.ChangeEventHandler<HTMLInputElement> | undefined;
    value?: string | number | readonly string[] | undefined;
    name?: string | undefined;
}

export function DateInput({ onChange, value, name }: Props) {
    return (
        <input
            className="border-gray-300 border-2 rounded text-gray-600 text-center"
            onChange={onChange}
            value={value}
            name={name}
            type="date" />
    );
}
